module.exports = __webpack_public_path__ + "media/images/element/idea-c3f67935724971c32f17b8cc790b9d54.svg";